/** One server-sent event. */
export type SseMessage = { id?: string; event?: string; data: string; retry?: number }

/** Incremental text/event-stream parser (WHATWG rules: fields, comments,
 *  multi-line data, blank line dispatch). Feed it chunks as they arrive. */
export class SseParser {
  private buf = ''
  private data: string[] = []
  private id?: string
  private event?: string
  private retry?: number

  push(chunk: string): SseMessage[] {
    this.buf += chunk
    const out: SseMessage[] = []
    for (;;) {
      const nl = this.buf.search(/\r\n|\r|\n/)
      if (nl < 0) break
      const line = this.buf.slice(0, nl)
      const len = this.buf.startsWith('\r\n', nl) ? 2 : 1
      this.buf = this.buf.slice(nl + len)
      if (line === '') {
        if (this.data.length > 0 || this.event || this.id) {
          out.push({ id: this.id, event: this.event, data: this.data.join('\n'), retry: this.retry })
        }
        this.data = []
        this.event = undefined
        this.retry = undefined
        continue
      }
      if (line.startsWith(':')) continue
      const colon = line.indexOf(':')
      const field = colon < 0 ? line : line.slice(0, colon)
      let value = colon < 0 ? '' : line.slice(colon + 1)
      if (value.startsWith(' ')) value = value.slice(1)
      switch (field) {
        case 'data':
          this.data.push(value)
          break
        case 'event':
          this.event = value
          break
        case 'id':
          if (!value.includes('\0')) this.id = value
          break
        case 'retry':
          if (/^\d+$/.test(value)) this.retry = Number(value)
          break
      }
    }
    return out
  }
}
